import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: () => import('./views/Home.vue')
		},
		{
			path: '/core',
			name: 'core',
			// component: Core
			component: () => import(/* webpackChunkName: "about" */ './views/Core.vue')
		},
		{
			path: '/rocio',
			name: 'rocio',
			component: () => import(/* webpackChunkName: "about" */ './views/Rocio.vue')
		},
		{
			path: '/faq',
			name: 'faq',
			component: () => import(/* webpackChunkName: "about" */ './views/Faq.vue')
		},
		{
			path: '/brand',
			name: 'brand',
			component: () => import(/* webpackChunkName: "about" */ './views/Brand.vue')
		},
		{
			path: '/filosofia',
			name: 'filosofia',
			component: () => import(/* webpackChunkName: "about" */ './views/Paihuen.vue')
		},
		{
			path: '/acerca',
			name: 'acerca',
			component: () => import(/* webpackChunkName: "about" */ './views/Acerca.vue')
		}
	],
	scrollBehavior () {
		return new Promise(resolve => {
			setTimeout(() => {
				resolve({ x: 0, y: 0 })
			}, 500)
		})
	}
})

// global.jQuery = require('jquery');
// var $ = global.jQuery;
// window.$ = $;

// window.onload = function () {

// //
// // Menú
// //
// var
// body                        = $('body'),
// main                        =   body,
// nav                           = $('nav li a'),
// page                        = $('[attr-page]');

// var
// percent = 0;

// var
// menu                      =   $('.p-header .menu'),
// menuTriggerButton   =   $('.p-header-menu-trigger'),
// menuItem                =   $('.p-header .menu .nav-item'),
// menuState               =     false;

// function menuTrigger(menuState){
//   menuState = menuState;
//   if(menuState  ===   true){
//     menu.toggleClass('active');
//     menuItem.show();
//   }
//   if(menuState  ===   false){
//     menu.removeClass('active');
//     setTimeout(function () {
//       menuItem.hide();
//     }, 300);
//   }
// }

// menuTrigger(menuState);

// menuTriggerButton.on('click', function(e){

//   if(menuState  ===   false){
//     menuState       =   true;
//     menuTrigger(menuState);
//   }else{
//     menuState       =   false;
//     menuTrigger(menuState);
//   }
// });

// menuItem.click(function(){
//   menuState       =   false;
//   menuTrigger(menuState);
// });

// //
// // Mailchimp
// //

// var mailchimpInput = $('#mce-EMAIL');

// mailchimpInput.focus(function() {
//   $('#mc-embedded-subscribe-form .input-group').addClass('active');
// });

// mailchimpInput.blur(function() {
//   $('#mc-embedded-subscribe-form .input-group').removeClass('active');
// });

// $( document ).ready(function() {
//   // detecta click fuera de menu
//   body.on('click', function(e){
//     if (!menu.is(e.target) && menu.has(e.target).length === 0) {
//       menuState       =   false;
//       menuTrigger(menuState);
//     }
//   });
// });


// }


